import React from "react";
import SearchIcon from "../../static/icons/search";
import { Form } from "react-bootstrap";

const SearchBar = ({ onChange, value, ref, placeholder }) => {
  return (
    <div className="d-flex justify-content-center align-items-center w-100 my-3">
      <Form
        className="w-100"
        style={{
          maxWidth: "650px",
          border: "1px solid #ced4da",
          borderRadius: "30px",
          padding: "5px 15px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          backgroundColor: "#ffffff",
        }}
      >
        <div className="d-flex align-items-center me-md-3 mb-3 mb-md-0">
          <SearchIcon
            className="me-2"
            style={{
              width: "20px",
              height: "20px",
              color: "#6c757d",
            }}
          />
          <Form.Control
            type="text"
            value={value}
            onChange={onChange}
            ref={ref}
            placeholder={placeholder}
            className="border-0"
            style={{
                
              fontSize: "16px",
              outline: "none",
              boxShadow: "none",
              padding: "8px",
            }}
          />
        </div>
      </Form>
    </div>
  );
};

export default SearchBar;
